module.exports = __webpack_public_path__ + "static/media/mailbox-empty.fcc709e6.svg";